<template>
    <div class="cta-caja cta-caja--lila" @click="clicking">
      <div class="cta-caja__cover">
        <img
          class="cta-caja__cover-desk"
          src="../../../assets/img/covers/cover-cta-hamaca-babybjorn.jpg"
          alt=""
        />
        <img
          class="cta-caja__cover-mobile"
          src="../../../assets/img/covers/cover-cta-hamaca-babybjorn-m.png"
          alt=""
        />
      </div>
      <div class="cta-caja__content">
        <h4 class="cta-caja__title">La hamaca favorita de tu peque</h4>
        <div class="cta-caja__description">
          <p>Suave, cómoda y fácil de transportar a cualquier rincón de tu casa.</p>
        </div>
        <div class="cta-caja__actions">
          <loading-button v-if="loading" :class="'button-loading--sm'" />
          <button
            v-else
            class="button button--accent button--sm button--ico"
            @click.stop="addProduct('Constructor - Banner Horitzontal')"
            :disabled="added"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
      <modal-dialog
          :show="showProductAddedDialog"
          @close="showProductAddedDialog = false"
          target-class="modal__card--mini"
      >
        <product-added-to-list/>
      </modal-dialog>
    </div>
  </template>
  
  <script>
  import Product from "./Mixins/Product";
  import LoadingButton from "../../../components/LoadingButton";
  import ModalDialog from "../../../components/ui/ModalDialog";
  import ProductAddedToList from "../../../components/ProductAddedToList";
  
  export default {
    name: "CtaHamacaBabybjorn",
    mixins: [Product],
    components: {
      LoadingButton,
      ModalDialog,
      ProductAddedToList
    },
    computed: {
      buttonText() {
        return this.added ? "Añadido" : "Añadir a mi lista";
      },
    },
    created() {
      this.product = {
        id: 41759,
        name: "Hamaca BabyBjörn Bliss",
        "brand-slug": "hamaca-babybjorn-bliss",
        retailerName: "Amazon",
        productRetailers: [{"name": "Amazon"},{"name": "BabyBjörn"},{"name": "El Corte Inglés"}]
      };
    },
    methods: {
      clicking()
      {
        mixpanel.track("Click element constructor", {
          "Name": "Hamaca BabyBjörn Bliss",
          "Section": "Secció inicial",
          "Section number": 0,
          "Type": "Banner - Horizontal",
          "Content": "Ecommerce"
        });
        this.browseProduct();
      }
    }
  };
  </script>